'use strict';

import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import TweenMax from 'gsap/src/uncompressed/TweenMax';
import TimelineMax from 'gsap/src/uncompressed/TimelineMax';

/**
 * @classname TopParallax
 * @classdesc TOPパララックス
 */
export default class TopParallax {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('TopParallax.constructor');
		this._controller = new ScrollMagic.Controller();
		this.pinHeader();
		this.serviceAnimation();
		this.recruitAnimation();
		this.btnAnimation();
		const height = $(window).height();
		console.log(height);
		$(window).scroll(function(){
			const sc = $(this).scrollTop();
			if(sc > height){
				$('.image--company-bg').show();
			}
		})
	};


	/**
	 * ヘッダー固定
	 *
	 * @memberof TopParallax
	 * @return {undefined}
	 */
	pinHeader() {
		console.log('TopParallax.pinHeader');
		const scene = new ScrollMagic.Scene({
			triggerElement: '#header-top-pc',
			triggerHook: 'onLeave'
		})
		.setPin('#header-top-pc')
		.setClassToggle('#header-top-pc', 'fixed')
		//.addIndicators({name: '1: header'})
		.addTo(this._controller);
	};


	/**
	 * 業務内容
	 *
	 * @memberof TopParallax
	 * @return {undefined}
	 */
	serviceAnimation() {
		console.log('TopParallax.serviceAnimation');
		//if($(window).width() >= 768){
			const item = $('.list--services .list__item');
			for(let i = 0; i < item.length; i++){
				new ScrollMagic.Scene({
					triggerElement: item[i],
					triggerHook: 'onEnter',
					offset: 50,
					reverse: false
				})
				.setClassToggle(item[i], 'visible')
				//.addIndicators({name: '2: service'})
				.addTo(this._controller);
			}
		//}
	};


	/**
	 * 採用
	 *
	 * @memberof TopParallax
	 * @return {undefined}
	 */
	recruitAnimation() {
		console.log('TopParallax.serviceAnimation');
		const item = $('.list--recruit .list__item');
		for(let i = 0; i < item.length; i++){
			new ScrollMagic.Scene({
				triggerElement: item[i],
				triggerHook: 'onEnter',
				offset: 50
			})
			.setClassToggle(item[i], 'visible')
			.addTo(this._controller);
		}
	};


	/**
	 * ボタン
	 *
	 * @memberof TopParallax
	 * @return {undefined}
	 */
	btnAnimation() {
		console.log('TopParallax.btnAnimation');
		const btn = $('.btn--scroll');
		for(let i = 0; i < btn.length; i++){
			new ScrollMagic.Scene({
				triggerElement: btn[i],
				triggerHook: 'onEnter',
				reverse: false
			})
			.setClassToggle(btn[i], 'visible')
			//.addIndicators({name: '4: btn'})
			.addTo(this._controller);
		}
	};
};